import React from 'react';
import { connect } from 'react-redux';
import AuditAction from '@/audit/components/AuditAction';
import { userUrl } from '@/constants/urls';
import ReassignUserAction from '@/roles/containers/ReassignUserAction';
import findResult from '@/utils/resultsHelper';
import UserApproveAction from './UserApproveAction';
import UserArchiveAction from './UserArchiveAction';

const UserActions = ({
  allowAudit,
  allowRoleAssign,
  canApprove,
  canArchive,
  category,
  code,
  url,
}) => (
  <>
    {allowRoleAssign && (<ReassignUserAction category={category} code={code} />)}
    {canApprove && (<UserApproveAction category={category} code={code} />)}
    {allowAudit && (<AuditAction baseUrl={url} />)}
    {canArchive && (<UserArchiveAction category={category} code={code} />)}
  </>
);

const mapStateToProps = ({
  auth: { role: { permissions }, currentUser, users },
}, { category, code }) => {
  const item = findResult(users, category, code) || { archived: false, approved: false };
  const isActive = !item.archived;
  const isCurrentUser = code === currentUser.id;

  return ({
    allowAudit: permissions.users.audit || isCurrentUser,
    allowRoleAssign: permissions.roles.assign && isActive,
    canApprove: permissions.users.approve && (isActive || item.approved),
    canArchive: permissions.users.destroy,
    url: userUrl(item, '#'),
  });
};

export default connect(mapStateToProps)(UserActions);
